<template>
  <div v-if="showCookiesBar">
    <div
      id="cookie-bar"
      class="fixed bottom"
    >
      <p v-html="$t('lang.alerts.cookies_message')" />
      <b-link
        href="#"
        class="cb-policy"
        @click="agreeWithCookies()"
      >
        {{ $t('lang.alerts.cookies_button') }}
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cookies',
  data() {
    return {
      showCookiesBar: true,
    };
  },

  created() {
    if (this.$store.state.main.acceptedCookies) {
      this.showCookiesBar = false;
    }
  },

  methods: {
    agreeWithCookies() {
      this.$store.dispatch('setCookiesConfig', true);
      this.showCookiesBar = false;

      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });

      dataLayer.push({
        event: 'cookie_consent',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted',
      });
    },
  },
};
</script>

<style scoped>

</style>
